import { OverlayModule } from '@angular/cdk/overlay';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckBoxModule } from '@duoduo-oba/ng-devui/checkbox';
import { LoadingModule } from '@duoduo-oba/ng-devui/loading';
import { DocumentRef, WindowRef } from '@duoduo-oba/ng-devui/window-ref';
import { SelectComponent } from './select.component';
import { LazyLoadModule } from '@duoduo-oba/ng-devui/utils';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    OverlayModule,
    ScrollingModule,
    CheckBoxModule,
    LoadingModule,
    LazyLoadModule
  ],
  exports: [
    SelectComponent,
  ],
  declarations: [
    SelectComponent
  ],
  providers: [
    WindowRef,
    DocumentRef,
  ]
})
export class SelectModule { }
